import numeral from "numeral"; // load a locale

if (numeral.locales["DE"] === undefined && numeral.locales["de"] === undefined) {
  numeral.register("locale", "DE", {
    delimiters: {
      thousands: ".",
      decimal: ","
    },
    abbreviations: {
      thousand: "k",
      million: "mm",
      billion: "b",
      trillion: "t"
    },
    ordinal: function ordinal(number) {
      var b = number % 10;
      return b === 1 || b === 3 ? "er" : b === 2 ? "do" : b === 7 || b === 0 ? "mo" : b === 8 ? "vo" : b === 9 ? "no" : "to";
    },
    currency: {
      symbol: "€"
    }
  });
}

if (numeral.locales["FR"] === undefined && numeral.locales["fr"] === undefined) {
  numeral.register("locale", "FR", {
    delimiters: {
      thousands: ".",
      decimal: ","
    },
    abbreviations: {
      thousand: "k",
      million: "mm",
      billion: "b",
      trillion: "t"
    },
    ordinal: function ordinal(number) {
      var b = number % 10;
      return b === 1 || b === 3 ? "er" : b === 2 ? "do" : b === 7 || b === 0 ? "mo" : b === 8 ? "vo" : b === 9 ? "no" : "to";
    },
    currency: {
      symbol: "€"
    }
  });
}

if (numeral.locales["IT"] === undefined && numeral.locales["it"] === undefined) {
  numeral.register("locale", "IT", {
    delimiters: {
      thousands: ".",
      decimal: ","
    },
    abbreviations: {
      thousand: "k",
      million: "mm",
      billion: "b",
      trillion: "t"
    },
    ordinal: function ordinal(number) {
      var b = number % 10;
      return b === 1 || b === 3 ? "er" : b === 2 ? "do" : b === 7 || b === 0 ? "mo" : b === 8 ? "vo" : b === 9 ? "no" : "to";
    },
    currency: {
      symbol: "€"
    }
  });
}

if (numeral.locales["NL"] === undefined && numeral.locales["nl"] === undefined) {
  numeral.register("locale", "NL", {
    delimiters: {
      thousands: ".",
      decimal: ","
    },
    abbreviations: {
      thousand: "k",
      million: "mm",
      billion: "b",
      trillion: "t"
    },
    ordinal: function ordinal(number) {
      var b = number % 10;
      return b === 1 || b === 3 ? "er" : b === 2 ? "do" : b === 7 || b === 0 ? "mo" : b === 8 ? "vo" : b === 9 ? "no" : "to";
    },
    currency: {
      symbol: "€"
    }
  });
}

if (numeral.locales["ES"] === undefined && numeral.locales["es"] === undefined) {
  numeral.register("locale", "ES", {
    delimiters: {
      thousands: ".",
      decimal: ","
    },
    abbreviations: {
      thousand: "k",
      million: "mm",
      billion: "b",
      trillion: "t"
    },
    ordinal: function ordinal(number) {
      var b = number % 10;
      return b === 1 || b === 3 ? "er" : b === 2 ? "do" : b === 7 || b === 0 ? "mo" : b === 8 ? "vo" : b === 9 ? "no" : "to";
    },
    currency: {
      symbol: "€"
    }
  });
}

if (numeral.locales["BR"] === undefined && numeral.locales["br"] === undefined) {
  numeral.register("locale", "BR", {
    delimiters: {
      thousands: ".",
      decimal: ","
    },
    abbreviations: {
      thousand: "k",
      million: "mm",
      billion: "b",
      trillion: "t"
    },
    ordinal: function ordinal(number) {
      var b = number % 10;
      return b === 1 || b === 3 ? "er" : b === 2 ? "do" : b === 7 || b === 0 ? "mo" : b === 8 ? "vo" : b === 9 ? "no" : "to";
    },
    currency: {
      symbol: "R$"
    }
  });
}

if (numeral.locales["CZ"] === undefined && numeral.locales["cz"] === undefined) {
  numeral.register("locale", "CZ", {
    delimiters: {
      thousands: ".",
      decimal: ","
    },
    abbreviations: {
      thousand: "k",
      million: "mm",
      billion: "b",
      trillion: "t"
    },
    ordinal: function ordinal(number) {
      var b = number % 10;
      return b === 1 || b === 3 ? "er" : b === 2 ? "do" : b === 7 || b === 0 ? "mo" : b === 8 ? "vo" : b === 9 ? "no" : "to";
    },
    currency: {
      symbol: "Kč"
    }
  });
}

if (numeral.locales["PA"] === undefined && numeral.locales["pa"] === undefined) {
  numeral.register("locale", "PA", {
    delimiters: {
      thousands: ".",
      decimal: ","
    },
    abbreviations: {
      thousand: "k",
      million: "mm",
      billion: "b",
      trillion: "t"
    },
    ordinal: function ordinal(number) {
      var b = number % 10;
      return b === 1 || b === 3 ? "er" : b === 2 ? "do" : b === 7 || b === 0 ? "mo" : b === 8 ? "vo" : b === 9 ? "no" : "to";
    },
    currency: {
      symbol: "USD"
    }
  });
}

if (numeral.locales["UY"] === undefined && numeral.locales["uy"] === undefined) {
  numeral.register("locale", "UY", {
    delimiters: {
      thousands: ".",
      decimal: ","
    },
    abbreviations: {
      thousand: "k",
      million: "mm",
      billion: "b",
      trillion: "t"
    },
    ordinal: function ordinal(number) {
      var b = number % 10;
      return b === 1 || b === 3 ? "er" : b === 2 ? "do" : b === 7 || b === 0 ? "mo" : b === 8 ? "vo" : b === 9 ? "no" : "to";
    },
    currency: {
      symbol: "USD"
    }
  });
}

if (numeral.locales["CL"] === undefined && numeral.locales["cl"] === undefined) {
  numeral.register("locale", "CL", {
    delimiters: {
      thousands: ".",
      decimal: ","
    },
    abbreviations: {
      thousand: "k",
      million: "mm",
      billion: "b",
      trillion: "t"
    },
    ordinal: function ordinal(number) {
      var b = number % 10;
      return b === 1 || b === 3 ? "er" : b === 2 ? "do" : b === 7 || b === 0 ? "mo" : b === 8 ? "vo" : b === 9 ? "no" : "to";
    },
    currency: {
      symbol: "CLP"
    }
  });
}

if (numeral.locales["CO"] === undefined && numeral.locales["co"] === undefined) {
  numeral.register("locale", "CO", {
    delimiters: {
      thousands: ".",
      decimal: ","
    },
    abbreviations: {
      thousand: "k",
      million: "mm",
      billion: "b",
      trillion: "t"
    },
    ordinal: function ordinal(number) {
      var b = number % 10;
      return b === 1 || b === 3 ? "er" : b === 2 ? "do" : b === 7 || b === 0 ? "mo" : b === 8 ? "vo" : b === 9 ? "no" : "to";
    },
    currency: {
      symbol: "COP"
    }
  });
}

if (numeral.locales["MX"] === undefined && numeral.locales["mx"] === undefined) {
  numeral.register("locale", "MX", {
    delimiters: {
      thousands: ".",
      decimal: ","
    },
    abbreviations: {
      thousand: "k",
      million: "mm",
      billion: "b",
      trillion: "t"
    },
    ordinal: function ordinal(number) {
      var b = number % 10;
      return b === 1 || b === 3 ? "er" : b === 2 ? "do" : b === 7 || b === 0 ? "mo" : b === 8 ? "vo" : b === 9 ? "no" : "to";
    },
    currency: {
      symbol: "MX$"
    }
  });
}

if (numeral.locales["PE"] === undefined && numeral.locales["pe"] === undefined) {
  numeral.register("locale", "PE", {
    delimiters: {
      thousands: ".",
      decimal: ","
    },
    abbreviations: {
      thousand: "k",
      million: "mm",
      billion: "b",
      trillion: "t"
    },
    ordinal: function ordinal(number) {
      var b = number % 10;
      return b === 1 || b === 3 ? "er" : b === 2 ? "do" : b === 7 || b === 0 ? "mo" : b === 8 ? "vo" : b === 9 ? "no" : "to";
    },
    currency: {
      symbol: "S/."
    }
  });
}

if (numeral.locales["BO"] === undefined && numeral.locales["bo"] === undefined) {
  numeral.register("locale", "BO", {
    delimiters: {
      thousands: ".",
      decimal: ","
    },
    abbreviations: {
      thousand: "k",
      million: "mm",
      billion: "b",
      trillion: "t"
    },
    ordinal: function ordinal(number) {
      var b = number % 10;
      return b === 1 || b === 3 ? "er" : b === 2 ? "do" : b === 7 || b === 0 ? "mo" : b === 8 ? "vo" : b === 9 ? "no" : "to";
    },
    currency: {
      symbol: "Bs"
    }
  });
}

if (numeral.locales["CH"] === undefined && numeral.locales["ch"] === undefined) {
  numeral.register("locale", "CH", {
    delimiters: {
      thousands: ".",
      decimal: ","
    },
    abbreviations: {
      thousand: "k",
      million: "mm",
      billion: "b",
      trillion: "t"
    },
    ordinal: function ordinal(number) {
      var b = number % 10;
      return b === 1 || b === 3 ? "er" : b === 2 ? "do" : b === 7 || b === 0 ? "mo" : b === 8 ? "vo" : b === 9 ? "no" : "to";
    },
    currency: {
      symbol: "Fr"
    }
  });
}

if (numeral.locales["KW"] === undefined && numeral.locales["kw"] === undefined) {
  numeral.register("locale", "KW", {
    delimiters: {
      thousands: ".",
      decimal: ","
    },
    abbreviations: {
      thousand: "k",
      million: "mm",
      billion: "b",
      trillion: "t"
    },
    ordinal: function ordinal(number) {
      var b = number % 10;
      return b === 1 || b === 3 ? "er" : b === 2 ? "do" : b === 7 || b === 0 ? "mo" : b === 8 ? "vo" : b === 9 ? "no" : "to";
    },
    currency: {
      symbol: "KWD"
    }
  });
} // switch between locales
// numeral.locale('es');


var setLocale = function setLocale(locale) {
  console.log("locale en setLocale", locale);
  locale ? locale === "all" || locale === "ALL" ? numeral.locale("ES") : numeral.locale(locale) : numeral.locale("ES");
};

export { setLocale };
export default numeral;